
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { AvatarVO } from "../../../gamevo/AvatarVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2AvatarCardDialogProperties } from "./Poker2AvatarCardDialogProperties";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2AvatarCardDialog extends Poker2Dialog {
    public static NAME: string = "Poker2RankingAvatarDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected applyProperties(): void {
        this.updateAvatar(this.rankingAvatarProperties.rankingAvatarVO.avatar);
        this.rankingAvatarDialog.txt_rankname.text = Poker2Model.userData.generateTitle(this.rankingAvatarProperties.rankingAvatarVO.level);
        this.rankingAvatarDialog.txt_name.text = this.rankingAvatarProperties.rankingAvatarVO.name;
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(8, this.rankingAvatarDialog.txt_level,  String(this.rankingAvatarProperties.rankingAvatarVO.level));
        this.rankingAvatarDialog.txt_chips.text = NumberStringHelper.groupString(this.rankingAvatarProperties.rankingAvatarVO.chips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData);
        this.rankingAvatarDialog.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    private updateAvatar(avatarVO: AvatarVO): void {
        while (this.rankingAvatarDialog.mc_avatarholder.numChildren > 0) {
            this.rankingAvatarDialog.mc_avatarholder.removeChildAt(0);
        }
        /// var mcAvatar:Sprite = AvatarHelper.drawAvatarByItemArray( Poker2Model.avatarData.getAvatarClothesArray( avatarVO ));
        var mcAvatar: Container = new AvatarHolder(avatarVO);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        var scaleFactor: number = (240 / bounds.width);

        if ((bounds.height * scaleFactor) > 240)
            scaleFactor = (240 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

        this.rankingAvatarDialog.mc_avatarholder.addChild(mcAvatar);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.rankingAvatarDialog.btn_close:
                this.hide();
                break;
            case this.rankingAvatarDialog.btn_stats:
                var paramObject: any = { id: this.rankingAvatarProperties.rankingAvatarVO.id };
                BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
                break;
        }
    }

    protected get rankingAvatarProperties(): Poker2AvatarCardDialogProperties {
        return this.properties as Poker2AvatarCardDialogProperties;
    }

    protected get rankingAvatarDialog(): Library.PokerInterface.RankingAvatarCard {
        return this.disp as Library.PokerInterface.RankingAvatarCard;
    }
}
import { AvatarHolder } from "../../helper/AvatarHolder";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import {Poker2TextFieldHelper} from "../../helper/Poker2TextFieldHelper";
